<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-container>
      <h2>Afiş Güncelle</h2>

      <v-row style="margin-top: 50px;">
        <v-col cols="12" md="6">
          <h4>Başlık</h4>
          <v-text-field
            v-model="bannerDetails.title"
            maxlength="255"
            counter="255"
            :rules="titleRules"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <h4>
            Öncelik
            <v-icon
              style="font-size: 17px;"
              v-if="!alertPriority"
              color="#4d48f9"
              @click="alertPriority = !alertPriority"
            >
              info
            </v-icon>

            <v-alert
              v-model="alertPriority"
              border="left"
              close-text="Close Alert"
              color="#4d48f9"
              dark
              dismissible
            >
              Kampanyanın uygulamadaki sırasını belirtir.
            </v-alert>
          </h4>
          <v-text-field
            v-model="bannerDetails.order"
            type="number"
            min="1"
            required
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <h4>
            Link
            <v-icon
              style="font-size: 17px;"
              v-if="!alertLink"
              color="#4d48f9"
              @click="alertLink = true"
            >
              info
            </v-icon>

            <v-alert
              v-model="alertLink"
              border="left"
              close-text="Close Alert"
              color="#4d48f9"
              dark
              dismissible
            >
              Link eklerken http, https protokollerinin girilmesi gereklidir.
              <br />
              Örneğin: http://frink.com.tr, https://frink.com.tr
            </v-alert>
          </h4>
          <v-text-field
            v-model="bannerDetails.link"
            maxlength="255"
            counter="255"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <h4>Son Kullanım Tarihi</h4>
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="bannerDetails.endDate"
                style="font-weight: bold;"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="bannerDetails.endDate"
              :min="new Date().toISOString().substring(0, 10)"
              @input="menu = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <h4>Aktif/Pasif</h4>
          <v-checkbox
            v-model="bannerDetails.isActive"
            color="#4d48f9"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" md="6">
          <h4>Uygulama Türü</h4>
         <v-select
              v-model="bannerDetails.applicationType"
              :items="applicationTypes"
              item-text="name"
              item-value="value"
              data-vv-name="select"
              required
            ></v-select>         
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <h4>
            Görsel TR
            <v-icon
              style="font-size: 17px;"
              v-if="!infoImage"
              color="#4d48f9"
              @click="infoImage = true"
            >
              info
            </v-icon>
          </h4>

          <v-alert
            v-model="infoImage"
            border="left"
            close-text="Close Alert"
            color="#4d48f9"
            dark
            dismissible
          >
            Görsel boyutu: 654x400
            <br />
            Format: JPG
            <br />
            Dosya boyutu: Maximum 350 KB
          </v-alert>
          <v-img
            style="cursor: pointer;"
            v-if="
              (imgUrl !== '' && imgUrl !== undefined) ||
              (bannerDetails.img !== '' && bannerDetails.img !== undefined)
            "
            :src="imgUrl ? imgUrl : bannerDetails.img"
            aspect-ratio="1.7"
          ></v-img>
          <v-file-input
            show-size
            accept="image/*"
            v-model="bannerDetails.img"
            @change="previewFiles('tr')"
            label="Resim yükle"
            required
          ></v-file-input>
        </v-col>
        <v-col cols="6" md="6">
          <h4>
            Görsel EN
            <v-icon
              style="font-size: 17px;"
              v-if="!infoImageEn"
              color="#4d48f9"
              @click="infoImageEn = true"
            >
              info
            </v-icon>
          </h4>

          <v-alert
            v-model="infoImageEn"
            border="left"
            close-text="Close Alert"
            color="#4d48f9"
            dark
            dismissible
          >
            Görsel boyutu: 654x400
            <br />
            Format: JPG
            <br />
            Dosya boyutu: Maximum 350 KB
          </v-alert>
          <v-img
            style="cursor: pointer;"
            v-if="
              (imgUrlEn !== '' && imgUrlEn !== undefined) ||
              (bannerDetails.imgEn !== '' && bannerDetails.imgEn !== undefined)
            "
            :src="imgUrlEn ? imgUrlEn : bannerDetails.imgEn"
            aspect-ratio="1.7"
          ></v-img>
          <v-file-input
            show-size
            accept="image/*"
            v-model="bannerDetails.imgEn"
            @change="previewFiles('en')"
            label="Resim yükle"
            required
          ></v-file-input>
        </v-col>
      </v-row>
      <v-row style="gap: 12px; justify-content: flex-end;">
        <v-btn
          depressed
          color="error"
          style="text-transform: none !important; float: left; color: white;"
          @click="isDeleteModalOpen = true"
        >
          Sil
          <v-icon small>mdi-delete</v-icon>
        </v-btn>
        <v-btn
          depressed
          color="#4d48f9"
          style="text-transform: none !important; float: left; color: white;"
          @click="bannerUpdate()"
          :disabled="addButtonDisabled"
        >
          Güncelle
        </v-btn>
      </v-row>

      <v-dialog v-model="dialog" max-width="600">
        <v-card>
          <v-card-title class="headline">
            Lütfen alanları kontrol edin
          </v-card-title>

          <v-card-text>
            <ul>
              <li v-for="errorList in this.errorList" :key="errorList">
                {{ errorList }}
              </li>
            </ul>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="isDeleteModalOpen" max-width="300">
        <v-card style="text-align: center;">
          <v-card-title
            style="display: flex; justify-content: center;"
            class="headline"
          >
            Afiş Silinecek
          </v-card-title>

          <v-card-text>
            <p>Onayladığınız taktirde afiş silinecektir.</p>
            <v-row
              style="gap: 8px; justify-content: flex-end; margin-top: 12px;"
            >
              <v-btn
                depressed
                @click="isDeleteModalOpen = false"
                style="text-transform: none !important;"
              >
                İptal
              </v-btn>
              <v-btn
                depressed
                color="error"
                style="text-transform: none !important; color: white;"
                @click="bannerDelete()"
              >
                Sil
              </v-btn>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </v-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Banner',
  data: () => ({
    alert: false,
    infoImage: false,
    infoImageEn: false,
    alertPriority: false,
    alertLink: false,
    valid: true,
    titleRules: [
      (v) => !!v || 'Başlık alanı zorunludur.',
      (v) => v.length <= 255 || 'Maksimum 255 karakter olmalıdır.',
    ],
    imgUrl: '',
    imgUrlEn: '',
    imageRules: [
      (v) => !!v || 'Resim alanı zorunludur.',
      (v) =>
        (v && v.size <= 350 * 1024) ||
        'Dosya boyutu en fazla 350 KB olmalıdır.',
    ],
    errorList: [],
    dialog: false,
    addButtonDisabled: false,
    menu: false,
    isDeleteModalOpen: false,
    applicationTypes: [
      {
        name: 'UserApp',
        value: 'UserApp',
      },
      // {
      //   name: 'MerchantApp',
      //   value: 'MerchantApp',
      // },
    ],
  }),
  computed: mapGetters('banner', ['bannerDetails']),
  methods: {
    ...mapActions('banner', [
      'getBannerDetails',
      'updateBanner',
      'deleteBanner',
    ]),

    bannerUpdate() {
      this.addButtonDisabled = true

      if (this.$refs.form.validate()) {
        if (
          this.bannerDetails.link !== '' &&
          this.bannerDetails.linkText === ''
        ) {
          alert('Link metni alanı dolu olmalıdır')
          return
        }
        this.snackbar = true
        this.updateBanner(this.bannerDetails)
          .then((response) => {
            if (response.payload) {
              alert('Afiş başarıyla güncellendi.')
            } else {
              alert(response.friendlyMessage.message)
            }
          })
          .catch((err) => {
            const errors = err.response.data.errors
            if (errors && Object.keys(err.response.data.errors).length) {
              if (errors['Link']) {
                alert('Link alanını kontrol edin')
                return
              }
            }
            alert(err)
          })
          .finally(() => {
            this.addButtonDisabled = false
          })
      } else {
        var errors = []
        var x = document.getElementsByClassName('v-messages__message')
        for (var i = 0; i < x.length; i++) errors.push(x[i].innerHTML)
        this.errorList = errors
        this.dialog = true
        this.addButtonDisabled = false
      }
    },
    previewFiles(lang) {
      if (lang == 'tr') {
        if (this.bannerDetails.img === undefined) {
          this.imgUrl = ''
        } else {
          const file = this.bannerDetails.img
          this.imgUrl = URL.createObjectURL(file)
        }
      } else {
        if (this.bannerDetails.imgEn === undefined) {
          this.imgUrlEn = ''
        } else {
          const file = this.bannerDetails.imgEn
          this.imgUrlEn = URL.createObjectURL(file)
        }
      }
    },
    bannerDelete() {
      let id = this.$route.params.id
      this.deleteBanner(id).then((isDeleted) => {
        if (isDeleted) {
          alert('Afiş başarıyla silindi.')
          this.routeBanners()
        } else {
          alert('Afiş silinirken bir hata oluştu!')
        }
      })
    },
    routeBanners() {
      this.$router.push('/dashboard/banner/list')
    },
  },
  created() {
    let id = this.$route.params.id
    this.getBannerDetails(id)
      .then((data) => {
        this.imgUrl = data.imgUrl
        this.imgUrlEn = data.imgUrlEn
      })
      .catch(() => {
        this.routeBanners()
      })
  },
}
</script>
